"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Configurator = exports.type = void 0;
// TODO: refactor to work separately for each instance
var type;
(function (type) {
    type["insert"] = "insert";
    type["adapter"] = "adapter";
    type["single"] = "single";
})(type = exports.type || (exports.type = {}));
var ConfiguratorTabs = /** @class */ (function () {
    function ConfiguratorTabs() {
        this.init();
    }
    ConfiguratorTabs.prototype.init = function () {
        this.$configurators = $('.tedee-configurator');
        this.$configurators.each(function (index, configurator) { return new Configurator(configurator); });
    };
    return ConfiguratorTabs;
}());
exports.default = ConfiguratorTabs;
var Configurator = /** @class */ (function () {
    function Configurator(configurator) {
        this.$container = $(configurator);
        this.$tabNav = this.$container.find('.configurator-nav');
        this.$adapterInsertSwitch = this.$container.find('.switch-tab');
        this.$accordionSwitchTabButtons = this.$container.find('.switch-tab button');
        this.$accordionContainer = this.$container.find('.montagetype-content');
        this.tabNavButtons = this.$tabNav.find('a');
        this.addEventsListeners();
        this.defaultState();
    }
    Configurator.prototype.addEventsListeners = function () {
        var _this = this;
        this.$accordionSwitchTabButtons.each(function (i, item) {
            var type = $(item).data('montagetype');
            item.addEventListener('click', function (e) { return _this.switchTypeContent(type); });
        });
        this.tabNavButtons.each(function (i, item) {
            item.addEventListener('click', function (e) { return _this.updateAccordion(e, item); });
        });
    };
    Configurator.prototype.defaultState = function () {
        var _this = this;
        var defaultTab = this.$tabNav.data('default_montagetype');
        this.$accordionContainer.find('.configurator__item').hide();
        if (defaultTab) {
            // hide all items by default
            this.$tabNav.find(".montagetype__group").hide();
            this.$container.find(".montagetype-content").hide();
            // Select default Adapter/Insert switch
            this.$adapterInsertSwitch.find("[data-montagetype=\"".concat(defaultTab, "\"]")).addClass('active');
            this.$tabNav.find(".montagetype__group[data-montagetype=\"".concat(defaultTab, "\"]")).show();
            this.$container.find(".montagetype-content[data-montagetype=\"".concat(defaultTab, "\"]")).show();
        }
        else {
            this.$container.first().find('.montagetype-content').first().show();
        }
        // Select default variation for each group
        this.$tabNav.find('.montagetype__group').each(function (index, variationGroup) {
            var $firstItem = $(variationGroup).find('a').first();
            var firstItemId = $firstItem.data('option-tab-id');
            $firstItem.addClass('active');
            _this.$accordionContainer.find("[data-slug-category=\"".concat(firstItemId, "\"]")).show();
        });
    };
    Configurator.prototype.switchTypeContent = function (type) {
        this.$accordionSwitchTabButtons.removeClass('active');
        $(this.$tabNav.find(".montagetype__group")).hide();
        this.$tabNav.find(".montagetype__group[data-montagetype=\"".concat(type, "\"]")).show();
        this.$adapterInsertSwitch.find("[data-montagetype=\"".concat(type, "\"]")).addClass('active');
        this.$accordionContainer.hide();
        this.$accordionContainer.parent().find(".montagetype-content[data-montagetype=\"".concat(type, "\"]")).show();
    };
    Configurator.prototype.updateAccordion = function (e, item) {
        var _this = this;
        e.preventDefault();
        this.showItemSelection(item);
        $(item).siblings().each(function (index, element) { return _this.hideItemSelections(element); });
    };
    Configurator.prototype.showItemSelection = function (el) {
        var slug = $(el).data('option-tab-id');
        $(el).addClass('active');
        $(this.$accordionContainer).find(".configurator__item[data-slug-category=\"".concat(slug, "\"]")).show();
    };
    Configurator.prototype.hideItemSelections = function (el) {
        var slug = $(el).data('option-tab-id');
        $(el).removeClass('active');
        $(this.$accordionContainer).find(" .configurator__item[data-slug-category=\"".concat(slug, "\"]")).hide();
    };
    return Configurator;
}());
exports.Configurator = Configurator;
